const ExpandButton = ({onClick, className, ...rest}) => {

  return (
    <div className={`
      w-[6.8125rem] h-[6.8125rem] bg-[#172952] rounded-xl
      click-effect ${className}`}
      onClick={onClick}
      {...rest}>
      <svg xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 109.04 109.04">
          <g>
            <path d="M52.13,58.9a2.82,2.82,0,0,1-.73,2.72L30.91,82.11h9.66A2.82,2.82,0,0,1,43,83.52a2.81,2.81,0,0,1-2.41,4.21H24.12A2.77,2.77,0,0,1,21.34,85c0-.07,0-.13,0-.12V68.45a2.81,2.81,0,0,1,.81-2,2.94,2.94,0,0,1,2-.83,2.8,2.8,0,0,1,2.81,2.85v9.67L47.42,57.64a2.81,2.81,0,0,1,4.71,1.26Z" fill="#e2e2e2"/>
            <path d="M56.92,50.14a2.8,2.8,0,0,1,.72-2.72L78.13,26.93H68.47a2.78,2.78,0,0,1-2.4-1.41,2.81,2.81,0,0,1,2.4-4.21H84.93a2.77,2.77,0,0,1,1.94.79A2.71,2.71,0,0,1,87.7,24a.84.84,0,0,0,0,.13V40.59a2.84,2.84,0,0,1-.8,2,2.94,2.94,0,0,1-2,.83,2.77,2.77,0,0,1-2-.83,2.8,2.8,0,0,1-.82-2V30.91l-20.5,20.5a2.81,2.81,0,0,1-4.7-1.27Z" fill="#e2e2e2"/>
          </g>
      </svg>
    </div>
)};
export default ExpandButton;